export const blogList = [
    {
        id: 1,
        blogName: 'All About Venila JS',
        blogImage: 'https://images.unsplash.com/photo-1483058712412-4245e9b90334?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTZ8fGJsb2dzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60',
        authorLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR02rOHqiCwMQ4UUIhlRuTe73lbViLpyVzKQ3mkJlfATw&s',
        authorName: 'Stack Learner',
        blogCategory: 'Programming',
        blogDate: '18 Feb, 2022',
        readTime: '12 min read'
    },
    {
        id: 2,
        blogName: 'Full Stack Army',
        blogImage: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fGJsb2dzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60',
        authorLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR02rOHqiCwMQ4UUIhlRuTe73lbViLpyVzKQ3mkJlfATw&s',
        authorName: 'Stack Learner',
        blogCategory: 'Web Development',
        blogDate: '9 April, 2022',
        readTime: '12 min read'
    },
    {
        id: 3,
        blogName: 'Why I Left Vue.js for React',
        blogImage: 'https://miro.medium.com/max/875/0*5U6oqyhpaBWmF5Vb',
        authorLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCV7JHhlgF4k-Rm3NQNZXp0NL6zVUI1m0cTw&usqp=CAU',
        authorName: 'David Nienajadlo',
        blogCategory: 'Programming',
        blogDate: '08 Feb, 2022',
        readTime: '11 min read'
    },
    {
        id: 4,
        blogName: 'How to beacome a frontend developer',
        blogImage: 'https://miro.medium.com/max/875/1*cBqseW27AvIw-7e4ls1Nxw.jpeg',
        authorLogo: 'https://yt3.ggpht.com/ytc/AMLnZu_JuiwUKA8OSoT97avCn9xufJV0LsQFYJkMYdAq=s900-c-k-c0x00ffffff-no-rj',
        authorName: 'Programming Hero',
        blogCategory: 'Article',
        blogDate: '10 June, 2022',
        readTime: '14 min read'
    },
    {
        id: 5,
        blogName: 'Learn Material UI',
        blogImage: 'https://images.unsplash.com/photo-1516414447565-b14be0adf13e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YmxvZ3N8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60',
        authorLogo: 'https://yt3.ggpht.com/ytc/AMLnZu_JuiwUKA8OSoT97avCn9xufJV0LsQFYJkMYdAq=s900-c-k-c0x00ffffff-no-rj',
        authorName: 'Programming Hero',
        blogCategory: 'Article',
        blogDate: '01 Jan, 2022',
        readTime: '5 min read'
    },
    {
        id: 6,
        blogName: 'Learn React JS',
        blogImage: 'https://miro.medium.com/max/875/0*urj1fYqHHRPjgYvd.jpeg',
        authorLogo: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        authorName: 'Learn with sumit',
        blogCategory: 'Article',
        blogDate: '08 Feb, 2022',
        readTime: '11 min read'
    },
    {
        id: 7,
        blogName: 'Learn Tailwind',
        blogImage: 'https://images.unsplash.com/photo-1485988412941-77a35537dae4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YmxvZ3N8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60',
        authorLogo: 'https://avatars.githubusercontent.com/u/73503432?v=4',
        authorName: 'Learn with sumit',
        blogCategory: 'Programming',
        blogDate: '10 March, 2022',
        readTime: '8 min read'
    },
];
